import * as React from "react";
const partners = [{
  id: "partner-1",
  name: "St. Jude Surgical Center",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1613743/img/partner_logo_stjude.png"
}, {
  id: "partner-2",
  name: "Northwest Medical",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1613743/img/partner_logo_northwest.png"
}, {
  id: "partner-3",
  name: "Crestview Hospital",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1613743/img/partner_logo_crestview.png"
}, {
  id: "partner-4",
  name: "Summit Orthopedics",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1613743/img/partner_logo_summit.png"
}, {
  id: "partner-5",
  name: "Vanguard Health",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1613743/img/partner_logo_vanguard.png"
}, {
  id: "partner-6",
  name: "Apex Surgery Center",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1613743/img/partner_logo_apex.png"
}];
export default function TrustBar() {
  return;
}